import { routerReducer as router } from "react-router-redux";
import { combineReducers } from "redux";

import { loginReducer } from "../routes/Login/modules/login";

export const makeRootReducer = (asyncReducers) => {
  return combineReducers({
    // Add sync reducers here
    router,
    loginState: loginReducer,
    ...asyncReducers,
  });
};

export const injectReducer = (store, { key, reducer }) => {
  store.asyncReducers[key] = reducer;
  store.replaceReducer(makeRootReducer(store.asyncReducers));
};

export default makeRootReducer;



// WEBPACK FOOTER //
// ./src/store/reducers.js